export const LIST_PAYMENT = 'LIST_PAYMENT';
export const MY_PAYMENT = 'MY_PAYMENT';
export const DETAIL_PAYMENT = 'DETAIL_PAYMENT';

export const CONFIRM_BANK = 'CONFIRM_BANK';